<template>
    <div>
        <b-row class="service-prof-type">
            <b-col class="service-type-block" v-for="service in profServices" :key="service.name" @click="service.action">
                <img class="icon-service" :src="service.icon" alt>
                <div class="service-name mt-1" v-html="service.name"></div>
                <b-badge :class="{ 'blink': blinkSoonLabelActive }" v-if="service.name === $t('professionalServices.facilityRent')" variant="primary">{{ $t('soon-label') }}</b-badge>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
    components: {
		BBadge
    },
    data () {
        return {
            profServices: {
                sendMessage: {
                    name: this.$t('professionalServices.sendMessage'),
                    icon: '/static-appopensalud/img/icons/morillas-svg-icons/primary/chat.svg',
                    action: this.sendMessage
                },
                interconsultation: {
                    name: this.$t('professionalServices.interconsultation'),
                    icon: '/static-appopensalud/img/icons/morillas-svg-icons/primary/interconsultations.svg',
                    action: this.createInterconsultation
                },
                facilityRent: {
                    name: this.$t('professionalServices.facilityRent'),
                    icon: '/static-appopensalud/img/icons/morillas-svg-icons/primary/facility-rent.svg',
                    action: this.checkFacilities
                }
            },
            blinkSoonLabelActive: false
        }
    },
    methods: {
        sendMessage () {
            // Hay que crear la cita además de redirigir al chat
            this.$router.push('/professional/chats')
            // this.$helpers.goToWebApp('/HomeProfesional#/chat', this.$apiToken)
        },
        createInterconsultation () {
            // crea una cita normal pero se adjunta la historia clínica del paciente al que se refiere
        },
        checkFacilities () {
            this.highlightSoonLabel()
        },
        highlightSoonLabel () {
            this.blinkSoonLabelActive = true
            setTimeout(() => {
                this.blinkSoonLabelActive = false
            }, 4000)
        }
    }
}
</script>

<style lang="scss" scoped>
.service-type-block{
    text-align: center;
    -webkit-box-shadow: -10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);
    box-shadow: -10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);
    padding: 1.5rem 0.5rem;
    border-radius: 23px;
    border: 1px solid #eee;
    background-color: #eee;
    flex-basis: 50%;
    font-size: 11px;
    cursor: pointer;
    color: #2d5173;
    max-width: 220px;
}
.icon-service{
    width: 36px;
    height: 36px;
}
.blue{
    color: $blue;
}
.bold{
    font-weight: bold
}
.service-name{
    color: $blue;
    font-weight: bold;
    text-transform: uppercase;
}
.service-prof-type {
    display: flex;
    gap: 2rem;
    @include screen-xl-grid-max  {
      justify-content: center;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/professional/interconsultations/SearchBlocksProfessional.vue